import { MapPinIcon } from '@heroicons/react/24/solid'
import useTranslation from 'next-translate/useTranslation'
import styles from './styles.module.scss'

type Props = {
  companyAmount: string[]
}

const LocationMark = ({ companyAmount }: Props) => {
  const { t } = useTranslation('common')
  // naming due to https://github.com/aralroca/next-translate#5-plurals
  const count = companyAmount.length

  return (
    <div className={`${styles.cli} text-gray-450`}>
      <MapPinIcon />
      {`${count > 1 ? t('localizations_count', { count }) : companyAmount}`}
    </div>
  )
}

export default LocationMark
